import WizardModule from "../wizardmodule/WizardModule";

type Props = {
  collapsed?: boolean;
};

export default function InternalUsers({
  collapsed
}: Props) {

  const visibleModule = !collapsed && (
    <WizardModule moduleTitle="Kundteam Ludvig & Co" hideLoader>
     <>
     <p>
        Åtkomst till kund i MittKontor baseras på kundteamet i{" "}
        <i>MittLudvig - Mina uppdrag</i>. Har du kunden i <i>Mina uppdrag</i>,
        har du den också i MittKontor.
      </p>

      <p>
        Du har kunden i <i>Mina uppdrag</i> om <b>något</b> av följande gäller:
      </p>
      <ul className="standardComponentText">
        <li>
          Du är Kundansvarig, Uppdragsansvarig, DISA eller Delansvarig på något
          av kundens uppdrag i Maconomy
        </li>
        <li>Du är tillagd på kundteamet</li>
      </ul>

      <p>
        Om du vill arbeta med en kund du inte är tillagd på där kan du söka upp
        kunden och klicka på "Visa kund".
      </p>
     </>
    </WizardModule>
  );

  return <div>{visibleModule}</div>;
}
